import React, {Component} from 'react';
import { Link } from 'react-router';
import Helmet from "react-helmet";

import GuideButton from '../../components/GuideButton';
import GuideHeader from '../../components/GuideHeader';

export default class Temperature extends Component {
  render() {
    const imageUrl = "https://blacksquare.nyc3.digitaloceanspaces.com/janes_colony/guide/guide_header_flowering_2.jpg";
    return (
      <div>
        <Helmet
          title="Jane's Colony"
          meta={ [
            { name: "description", content: "" },
            { property: "og:title", content: ''},
            { property: "og:url", content: ''},
            { property: "og:image", content: ''},
          ] }
        />
        <GuideHeader imageUrl={imageUrl} />
        <h2>
          Temperature
        </h2>
        <p>
          Marijuana plants are like goldilocks, and finding that ‘just right’ temperature is key to a successful grow. Ideally, you’ll want to maintain a constant temperature between 73 and 82 degrees Fahrenheit (23 to 28 degrees Celsius). Remember that both the light source and bushy plants can increase your temperature. To help you maintain and monitor these levels, you’ll want to buy a <a target="_blank" href="https://www.amazon.com/gp/product/B0013BKDO8/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B0013BKDO8&linkCode=as2&tag=blacksquare05-20&linkId=12e79c3153b2b1201277867f66609088">Thermometer and Humidity Monitor</a><img src="//ir-na.amazon-adsystem.com/e/ir?t=blacksquare05-20&l=am2&o=1&a=B0013BKDO8" width="1" height="1" alt="" className="amazon__pixel" />. Regularly record the minimum and maximum temperatures in your grow room. Avoid swings in temperature between day and night as they can upset growth and cause your plants to stretch out. 
        </p>
        <p>
          Cold temperatures are dangerous. Temperatures lower than 60°F (15°C) will upset plant growth while freezing temperatures can shock or kill a cannabis plant. Alternatively, high temperatures during the flowering stage will slow down bud growth and reduce the potency of your buds. 
        </p>
        <div className="guide__shopping-list">
          <h3>Shopping List</h3>
          <iframe className="amazon__iframe" marginWidth="0" marginHeight="0" scrolling="no" frameBorder="0" src="//ws-na.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=US&source=ac&ref=tf_til&ad_type=product_link&tracking_id=blacksquare05-20&marketplace=amazon&region=US&placement=B0013BKDO8&asins=B0013BKDO8&linkId=a48868611462716a014a932ed58d0ecc&show_border=true&link_opens_in_new_window=true&price_color=333333&title_color=0066c0&bg_color=ffffff">
          </iframe>

        </div>
        <GuideButton slugTo="humidity" />
      </div>
    )
  }
}





// WEBPACK FOOTER //
// ./src/content/guide/one_temperature.js